import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "ghost-data",
    templateUrl: "./ghost-data.component.html",
    styleUrls: ["./ghost-data.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class GhostDataComponent implements OnInit {
    @Input("show")
    public show!: boolean;

    @Input("opacity")
    public opacity: number = 100;

    constructor() {}

    ngOnInit() {}
}
